module.exports = require("././angular-touch.js");


//////////////////
// WEBPACK FOOTER
// angular-touch (bower component)
// module id = 1421
// module chunks = 1